import { formatDate } from "@angular/common";
import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { isNullOrEmpty } from "@servicestack/client";
import { NzModalRef, NzNotificationService } from "ng-zorro-antd";
import { FieldTypeCode } from "src/app/utils/enum";
import { GetInfomationField } from "../../../../../models/forms-get.models";
import { FieldOption, FormFieldInfo, FormInfo } from '../../../../../models/forms-response.models';
import { FormsService } from '../../../../../services/forms.service';

@Component({
    selector: 'app-component-table-complex-modal',
    templateUrl: './table-complex-modal.component.html',
    styleUrls: ['./table-complex-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableComplexModalComponent implements OnInit, AfterContentChecked {
    @Input() template: string;
    @Input() formFieldCode: string;
    @Input() data: any;
    @Input() title: any;
    @Output() eventEmit = new EventEmitter();
    formGroup: FormGroup = this.formBuilder.group({});
    formFieldInfo: FormFieldInfo[];
    getInfomationField: GetInfomationField;
    formFieldOption: FieldOption[];
    formInfo: FormInfo;
    selectChildData: any;
    version: number;
    formFieldConfig: any;
    numberFormFieldInfo: any;
    taxCode = "";
    formCode = "";
    isFilledTableComplex: boolean = false;
    queryRegex: string;
    fieldCode: string;

    constructor(
        private formsService: FormsService,
        private nzModalNotification: NzNotificationService,
        private formBuilder: FormBuilder,
        private nzModalRef: NzModalRef,
        private cdref: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        if (this.template) {
            let arr = this.template.split('#');
            this.fieldCode = arr[0];
            this.version = arr.length > 1 ? parseInt(arr[1]) : 1;
        }
        this.formCode = localStorage.getItem('FORM_CODE');
        this.taxCode = localStorage.getItem('TAXCODE');
        this.getField();
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    getField() {
        this.getInfomationField = { FormCode: this.fieldCode, Version: this.version, Enviroment: 2 }
        this.formsService.getFieldCreateForm(this.getInfomationField).subscribe(res => {
            if (res.result.isSuccess) {
                this.formFieldInfo = res.result.value.result;
                this.formGroup = this.formBuilder.group({});
                this.formFieldInfo.forEach((value, index) => {
                    if (value.fieldTypeCode != FieldTypeCode.TITLE && value.fieldTypeCode != FieldTypeCode.LABEL) {
                        if (value.fieldTypeCode == FieldTypeCode.MULTIPLE_CHOICE) {
                            if (value.isRequired) {
                                this.formGroup.addControl(value.fieldCode, new FormControl('', Validators.required));
                            } else {
                                this.formGroup.addControl(value.fieldCode, new FormControl());
                            }
                            this.formGroup.addControl(value.fieldCode, new FormControl());
                            if (value.customfieldOptionList && value.customfieldOptionList.length > 0) {
                                value.customfieldOptionList.forEach(opt => {
                                    this.formGroup.addControl(opt.fieldCode + '-' + opt.optionCode, new FormControl());
                                });
                            }
                        }
                        else {
                            if (value.fieldTypeCode == FieldTypeCode.RADIO_BUTTON) {
                                if (value.isRequired) {
                                    this.formGroup.addControl(value.fieldCode, new FormControl('', Validators.required));
                                } else {
                                    this.formGroup.addControl(value.fieldCode, new FormControl());
                                }
                                this.formGroup.addControl(value.fieldCode, new FormControl());
                                if (value.customfieldOptionList && value.customfieldOptionList.length > 0) {
                                    value.customfieldOptionList.forEach(opt => {
                                        this.formGroup.addControl(opt.fieldCode + '-' + opt.optionCode + '_INPUT', new FormControl());
                                    });
                                }
                            }
                            else if (value.isRequired) {
                                this.formGroup.addControl(value.fieldCode, new FormControl('', Validators.required));
                            }
                            else {
                                this.formGroup.addControl(value.fieldCode, new FormControl());
                            }
                        }
                    }
                });

                this.queryRegex = this.formFieldCode ? `.${this.formFieldCode}` : null;

                if (this.data) {//display data when clicking edit
                    Object.keys(this.data).forEach(propName => {
                        if (propName.includes(FieldTypeCode.DATE) || propName.includes('Date')) {
                            if(this.data[propName]){
                                if (this.data[propName].includes('/') || this.data[propName].includes('-')) {
                                    if (this.data[propName].includes('/')) {
                                        const [day, month, year] = this.data[propName].split('/');
                                        const date = new Date(+year, +month - 1, +day);
                                        this.data[propName] = date.toString();
                                        localStorage.setItem(("VALUE_" + this.fieldCode + '_' + this.taxCode + '_' + propName), this.data[propName]);
                                    }
                                    else if (this.data[propName].includes('-')) {
                                        const [year, month, day] = this.data[propName].split('-');
                                        const date = new Date(+year, +month - 1, +day);
                                        this.data[propName] = date.toString();
                                    }
                                }
                            }
                        }
                        if (!localStorage.getItem(("VALUE_" + this.fieldCode + '_' + this.taxCode + '_' + propName))) {
                            localStorage.setItem(("VALUE_" + this.fieldCode + '_' + this.taxCode + '_' + propName), this.data[propName]);
                        }
                        if (!propName.includes('TEXT') && !propName.includes('TEXTEN') && !propName.includes('ISO')) {
                            let value = this.data[propName];
                            if (value) {
                                if (!propName.includes(FieldTypeCode.MULTIPLE_CHOICE)) {
                                    if (value.indexOf('|') > -1) {
                                        let splittedVal = value.split('|');
                                        value = splittedVal[0];
                                    }
                                }
                                else {
                                    if (typeof value != "boolean" && value.indexOf('#') > -1) {
                                        value = "";
                                        if(this.data[propName].includes('SMS') || this.data[propName].includes('EMAIL')){
                                            value = this.data[propName];
                                        }
                                        else{
                                            let splittedVal = this.data[propName].split('#');
                                            splittedVal.forEach(element => {
                                                let splittedSubVal = element.split('|');
                                                value += splittedSubVal[0];
                                                value += ',';
                                            });
                                        }
                                    }
                                }
                                if (typeof value != "boolean" && value.lastIndexOf(',') > -1) {
                                    value = value.slice(0, -1);
                                }
                            }
                            this.formGroup.controls[propName].setValue(value);
                        }
                    });
                }
            }
            else {
                this.nzModalNotification.error("Error", "Biểu mẫu chưa được hỗ trợ online");
            }
        }, error => {
            this.nzModalNotification.error("Error", "Biểu mẫu chưa được hỗ trợ online");
        })
    }

    getCol(item: any) {
        if (item.fieldTypeCode == FieldTypeCode.TITLE) {
            return 'col-md-12';
        }
        else {
            return 'col-md-' + (item.width * 12 / 3) + ' col-xs-12';
        }
    }

    saveForm() {
        if (this.validate(this.formFieldInfo)) {
            this.mappingObjectFromGroupData(this.formGroup.value);
            this.nzModalRef.destroy(this.formGroup.value);
        }
    }

    mappingObjectFromGroupData(fg: FormGroup) {
        let formData = this.formGroup.value; 
        const keys = Object.keys(fg);

        keys.forEach((key, index) => {
            let dataCodeTxt = "";
            let dataValText = "";
            let selectorComponent: any = "";
            if (!key.includes('TABLE')) {
                if (key.includes(FieldTypeCode.TEXT)) {
                    selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-text#TABLE_' + key + this.queryRegex));
                    if (selectorComponent != null) {
                        let temp = fg[key];
                        dataCodeTxt = temp;
                        dataValText = temp;
                        if (temp) {
                            this.formGroup.controls[key].setValue(temp);
                        }
                    }
                }
                else if (key.includes(FieldTypeCode.NUMBER)) {
                    selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-number#TABLE_' + key + this.queryRegex));
                    if (selectorComponent != null) {
                        dataCodeTxt = dataValText = this.formGroup.controls[key].value;
                    }
                }
                else if (key.includes(FieldTypeCode.TEXTAREA)) {
                    selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-textarea#TABLE_' + key + this.queryRegex));
                    if (selectorComponent != null) {
                        dataCodeTxt = dataValText = this.formGroup.controls[key].value;
                    }
                }
                else if (key.includes(FieldTypeCode.DATE)) {
                    selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-date#TABLE_' + key + this.queryRegex));
                    if (selectorComponent != null) {
                        if (this.formGroup.controls[key].value) {
                            dataCodeTxt = dataValText = formData[key] = formatDate(new Date(this.formGroup.controls[key].value), "MM/dd/yyyy", "en-US");
                        }
                    }
                }
                else if (key.includes(FieldTypeCode.DATETIME)) {
                    selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-datetime#TABLE_' + key + this.queryRegex));
                    if (selectorComponent != null) {
                        if (this.formGroup.controls[key].value) {
                            dataCodeTxt = dataValText = formatDate(new Date(this.formGroup.controls[key].value), "MM/dd/yyyy HH:mm", "en-US")
                        }
                    }
                }
                else if (key.includes(FieldTypeCode.CHECK_BOX)) {
                    selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-checkbox#TABLE_' + key + this.queryRegex));
                    if (selectorComponent != null) {
                        let valueCheckbox = selectorComponent.querySelector('label').getAttribute('data-value');
                        dataCodeTxt = dataValText = valueCheckbox;
                    }
                }
                else if (key.includes(FieldTypeCode.NUMBER_CURRENCY)) {
                    selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-number-currency#TABLE_' + key + this.queryRegex));
                    if (selectorComponent != null) {
                        dataCodeTxt = dataValText = this.formGroup.controls[key].value;
                    }
                }
                else if (key.includes(FieldTypeCode.TEXT_CHECK_BOX)) {
                    selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-text-checkbox#TABLE_' + key + this.queryRegex));
                    if (selectorComponent != null) {
                        dataCodeTxt = dataValText = this.formGroup.controls[key].value;
                    }
                }   
                else if (key.includes(FieldTypeCode.DATE_CHECK_BOX)) {
                    selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-date-checkbox#TABLE_' + key + this.queryRegex));
                    if (selectorComponent != null) {
                        dataCodeTxt = this.formGroup.controls[key].value;
                        dataValText = this.formGroup.controls[key].value;
                    }
                }
                else if (key.includes(FieldTypeCode.SELECTLIST_SINGLE)) {
                    selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-single-select#TABLE_' + key + this.queryRegex));
                    if (selectorComponent != null) {
                        let selectItem = selectorComponent.querySelector('nz-select');
                        let innerHtmlText = '';
                        if(selectItem){
                            let valueField = selectItem.getAttribute('title');
                            try{
                                innerHtmlText = selectItem ? selectorComponent.querySelector('nz-select-item').textContent : "";
                                if(innerHtmlText){
                                    dataCodeTxt = valueField + '|' + innerHtmlText;
                                    dataValText = innerHtmlText;
                                }
                                else{
                                    dataCodeTxt = dataValText = '';
                                }
                            }
                            catch(e){}
                        }
                    }
                }
                else if (key.includes(FieldTypeCode.MULTIPLE_CHOICE)) {
                    selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-multiple-choice#TABLE_' + key + this.queryRegex));
                    if (selectorComponent != null) {
                        var multiList: any = selectorComponent.querySelectorAll('nz-form-control label');
                        multiList.forEach(element => {
                            let isChecked = element.getAttribute('data-checked');
                            let dataMultiCode = element.getAttribute('data-nzvalue');
                            let dataMultiValue = element.getAttribute('data-multicheckbox');
                            if (isChecked == "true" || isChecked == true) {
                                this.getSubValues(key, dataMultiCode, this.formFieldInfo, 1);
                                let subInput = <HTMLInputElement>selectorComponent.querySelector(`#${key}-${dataMultiCode}_INPUT`);
                                if (subInput) {
                                    dataCodeTxt += dataMultiCode + '|' + dataMultiValue + '|' + subInput.value;
                                    dataCodeTxt += '#'
                                }
                                else {
                                    dataCodeTxt += dataMultiCode + '|' + dataMultiValue;
                                    dataCodeTxt += '#'
                                }
                            }
                        });
                        dataCodeTxt = (dataCodeTxt) ? dataCodeTxt.trim().slice(0, -1) : "";
                        dataValText = dataValText ? dataValText.trim().slice(0, -1) : "";
                        this.formGroup.controls[key].setValue(dataCodeTxt);
                    }
                }
                else if (key.includes(FieldTypeCode.RADIO_BUTTON)) {
                    selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-radiobutton#TABLE_' + key + this.queryRegex));
                    if (selectorComponent != null) {
                        let radioList: any = selectorComponent.querySelectorAll('nz-radio-group > label');
                        let selectedRadio = selectorComponent.querySelector('nz-radio-group').getAttribute('data-value');
                        radioList.forEach(element => {
                            let optionRadioCode = element.getAttribute('data-optioncode');
                            if (selectedRadio == optionRadioCode) {
                                this.getSubValues(key, selectedRadio, this.formFieldInfo, 0);
                                let selectedValueRadio = element.getAttribute('data-optionvalue');
                                var inputInRadio = (<HTMLInputElement><unknown>selectorComponent.querySelector('input#' + key + '-' + selectedRadio + '_INPUT'));
                                if (inputInRadio) {
                                    dataCodeTxt = selectedRadio + '|' + selectedValueRadio + '|' + inputInRadio.value;
                                    dataValText = selectedValueRadio + ': ' + inputInRadio.value;
                                }
                                else {
                                    dataCodeTxt = selectedRadio + '|' + selectedValueRadio;
                                    dataValText = selectedValueRadio;
                                }
                                this.formGroup.controls[key].setValue(dataCodeTxt);
                            }
                        });
                    }
                }

                if (!key.includes(FieldTypeCode.MULTIPLE_CHOICE) && !key.includes(FieldTypeCode.RADIO_BUTTON) && !key.includes(FieldTypeCode.NUMBER)) {
                    if((formData[key] || formData[key] != "") && (key.includes(FieldTypeCode.DATE) || key.includes(FieldTypeCode.DATETIME))){
                        if(key.includes(FieldTypeCode.DATE)){
                            formData[key] = formatDate(new Date(formData[key]), "MM/dd/yyyy", "en-US")
                        }
                        else if(key.includes(FieldTypeCode.DATETIME)){
                            formData[key] = formatDate(new Date(formData[key]), "MM/dd/yyyy HH:mm", "en-US")
                        }

                        this.formGroup.controls[key].setValue(formData[key])
                    }
                    else{
                        this.formGroup.controls[key].setValue(dataCodeTxt);
                    }
                }
            }
        });

        //Set lại key nếu key trên set null
        for(const key in this.formGroup.controls){
            if(!this.formGroup.controls[key].value){
                if(formData[key] && formData[key].dataTextField && formData[key].dataTextField.trim() != ''
                    && formData[key].dataValueField && formData[key].dataValueField.trim() != ''){
                    this.formGroup.controls[key].setValue(`${formData[key].dataValueField}|${formData[key].dataTextField}`)
                }
                else if(formData[key] && !formData[key].dataTextField && !formData[key].dataValueField){
                    this.formGroup.controls[key].setValue(`${formData[key]}`)
                }
            }
        }
    }

    getSubValues(selectedId: any, selectedValue: any, listfield: FormFieldInfo[], isMulti: any): any {
        let formData = this.formGroup.value;

        for (const el of listfield) {
            let key = "";
            let value = "";
            let text = "";
            let component_config = el.formFieldConfig ? JSON.parse(el.formFieldConfig) : "";
            let component_name = (component_config && component_config.displayText) ? component_config.displayText : el.name;
            let itemSubSection = component_config ? component_config.itemSubSection : "";
            let selectedSubSection = selectedId + '-' + selectedValue;
            if (selectedSubSection == itemSubSection) {
                if (itemSubSection) {
                    if (el.formFieldConfig.includes('itemSubSection')) {
                        key = el.fieldCode;
                        if (el.fieldTypeCode == FieldTypeCode.MULTIPLE_CHOICE) {
                            for (const opt of el.customfieldOptionList) {
                                if (opt.checked) {
                                    key = el.fieldCode;
                                    value += opt.optionCode + '|' + opt.selectedInput.trim() + '#';
                                    text += opt.selectedInput.trim() + ', ';
                                }
                            }
                            if (value != '' && value.lastIndexOf('#')) {
                                value = value.trim().slice(0, -1);
                            }
                            if (text != '' && text.lastIndexOf(',')) {
                                text = text.trim().slice(0, -1);
                            }
                            this.formGroup.controls[key].setValue(value);
                            this.getGrandChildrenOfCheckedData(el.fieldCode, FieldTypeCode.MULTIPLE_CHOICE, selectedId);
                        }
                        else if (el.fieldTypeCode == FieldTypeCode.RADIO_BUTTON) {
                            for (const opt of el.customfieldOptionList) {
                                if (this.formGroup.controls[el.fieldCode].value != undefined) {
                                    var checkedRadio = this.formGroup.controls[el.fieldCode] ? this.formGroup.controls[el.fieldCode].value : null;
                                    if (checkedRadio == opt.optionCode) {
                                        let inputInSubRadio: any = (<HTMLInputElement><unknown>document.querySelectorAll(`app-component-radiobutton.${selectedId} nz-form-control nz-radio-group input#${el.fieldCode}-${opt.optionCode}_INPUT`));
                                        if(!inputInSubRadio)
                                            inputInSubRadio = (<HTMLInputElement><unknown>document.querySelectorAll(`app-component-radiobutton${this.queryRegex} nz-form-control nz-radio-group input#${el.fieldCode}-${opt.optionCode}_INPUT`));
                                        if(!inputInSubRadio)
                                            inputInSubRadio = (<HTMLInputElement><unknown>document.querySelectorAll(`app-component-radiobutton nz-form-control nz-radio-group input#${el.fieldCode}-${opt.optionCode}_INPUT`));
                                        
                                            let radioInput = '';
                                        if (inputInSubRadio != null && inputInSubRadio.length > 0) {
                                            radioInput = inputInSubRadio[0].value;
                                        }
                                        if (radioInput != '') {
                                            value = opt.optionCode + '|' + opt.optionValue + '|' + radioInput;
                                        }
                                        else {
                                            value = opt.optionCode + '|' + opt.optionValue;
                                        }
                                        text = opt.optionValue;
                                        this.formGroup.controls[key].setValue(value);
                                        this.getGrandChildrenOfCheckedData(el.fieldCode, FieldTypeCode.RADIO_BUTTON, selectedId);
                                    }
                                }
                            }
                        }
                        else if (el.fieldTypeCode == FieldTypeCode.LABEL || el.fieldTypeCode == FieldTypeCode.TITLE) {
                        }
                        else if (el.fieldTypeCode == FieldTypeCode.SELECTLIST_SINGLE) {
                            if (this.formGroup.controls[el.fieldCode].value != undefined) {
                                value = this.formGroup.controls[el.fieldCode] ? this.formGroup.controls[el.fieldCode].value.dataValueField : null;
                                let selectorComponent = (<HTMLInputElement><unknown>document.querySelector(`app-component-single-select.${selectedId}#${key}${this.queryRegex}`));
                                if(!selectorComponent)
                                    selectorComponent = (<HTMLInputElement><unknown>document.querySelector(`app-component-single-select.${selectedId}#${key}`));
                                if(!selectorComponent)
                                    selectorComponent = (<HTMLInputElement><unknown>document.querySelectorAll(`app-component-single-select${this.queryRegex}#${key}`));
                                if(!selectorComponent)
                                    selectorComponent = (<HTMLInputElement><unknown>document.querySelectorAll(`app-component-single-select#${key}`));
                                        
                                
                                let queryEl = selectorComponent.querySelector('nz-select-item');
                                
                                if (selectorComponent && !isNullOrEmpty(queryEl)) {
                                    text = queryEl.textContent;
                                    value += '|' + text;
                                    this.formGroup.controls[key].setValue(value);
                                }
                            }
                        }
                        // else if (el.fieldTypeCode == FieldTypeCode.NUMBER) {
                        //     let selectorComponent = (<HTMLInputElement><unknown>document.querySelector(`app-component-number.${selectedId}#${key}`));
                        //     if(!selectorComponent)
                        //         selectorComponent = (<HTMLInputElement><unknown>document.querySelectorAll(`app-component-number${this.queryRegex}#${key}`));
                        //     if(!selectorComponent)
                        //         selectorComponent = (<HTMLInputElement><unknown>document.querySelectorAll(`app-component-number#${key}`));
                            
                        //     if (selectorComponent) {
                        //         let inputNumberComponent = selectorComponent.querySelector('nz-form-control');
                        //         if (inputNumberComponent) {
                        //             let text = inputNumberComponent.querySelector('input').value;
                        //             this.formGroup.controls[key].setValue(text);
                        //         }
                        //     }
                        // }
                        else {
                            if(formData[key].dataValueField && formData[key].dataTextField)
                                this.formGroup.controls[key].setValue(`${formData[key].dataValueField}|${formData[key].dataTextField}`);
                            else
                                this.formGroup.controls[key].setValue(formData[key]);
                        }
                    }
                }
            }
        }
    }

    getGrandChildrenOfCheckedData(selectedId: any, type: any, parentId?: any) {
        if (type === FieldTypeCode.MULTIPLE_CHOICE) {
            var multipleComponent: any = (<HTMLInputElement><unknown>document.querySelector(`app-component-multiple-choice.${parentId}#${selectedId} nz-form-control label`));
            
            let id = multipleComponent.getAttribute('data-name');
            let labelVal = multipleComponent.getAttribute('data-multicheckbox');;
            let isSticked = multipleComponent.getAttribute('data-checked');
            let value = multipleComponent.getAttribute('data-nzValue');
            if (isSticked === "true") {
                this.getSubValues(selectedId, value, this.formFieldInfo, 1);
            }
        }
        else {
            var radioComponent: any = (<HTMLInputElement><unknown>document.querySelector(`app-component-radiobutton.${parentId}#${selectedId} nz-radio-group`));
            var valueofRadio = radioComponent.getAttribute('data-value');
            if (valueofRadio != null && valueofRadio != undefined && valueofRadio != "undefined") {
                let id = radioComponent.getAttribute('id');
                this.getSubValues(id, valueofRadio, this.formFieldInfo, 0);
            }
        }
    }

    validate(listfield: FormFieldInfo[]): boolean {
        let flagCheck: boolean = true;

        for (const el of listfield) {
            let component_config = el.formFieldConfig ? JSON.parse(el.formFieldConfig) : "";
            let component_name = (component_config && component_config.displayText) ? component_config.displayText : el.name;
            let itemSubSection = component_config ? component_config.itemSubSection : "";

            if (el.isRequired) {
                if (itemSubSection) {
                    if (this.hasValue("", itemSubSection)) {
                        if (!this.hasValue(el.fieldCode, "")) {
                            this.nzModalNotification.error("Error", `Vui lòng nhập ${component_name} !`);
                            return false;
                        }
                    }
                }
                else if (el.fieldTypeCode == FieldTypeCode.MULTIPLE_CHOICE) {
                    let optionCount = 0;
                    for (const opt of el.customfieldOptionList) {
                        let isChecked = this.formGroup.controls[el.fieldCode + '-' + opt.optionCode].value;
                        if (isChecked) {
                            optionCount++;
                        }
                    }

                    if (optionCount == 0) {
                        this.nzModalNotification.error("Error", `Vui lòng nhập ${component_name} !`);
                        return false;
                    }
                } else {
                    let val = this.formGroup.controls[el.fieldCode] ? this.formGroup.controls[el.fieldCode].value : null;
                    let keydownPattern = el.fieldConfig ? JSON.parse(el.fieldConfig).keydownPattern : '';
                    if (el.fieldTypeCode == FieldTypeCode.NUMBER || el.fieldTypeCode == FieldTypeCode.NUMBER_CURRENCY) {
                        if (val == "0" || val == 0) {
                            this.nzModalNotification.error("Error", `Vui lòng nhập ${component_name} !`);
                            return false;
                        }
                    }

                    if (!val) {
                        this.nzModalNotification.error("Error", `Vui lòng nhập ${component_name} !`);
                        return false;
                    }
                    else if (keydownPattern && el.fieldTypeCode != FieldTypeCode.DATE && el.fieldTypeCode != FieldTypeCode.DATETIME) {
                        let regex = new RegExp(keydownPattern.toString());
                        let valid = regex.test(val);
                        if (!valid) {
                            this.nzModalNotification.error("Error", component_name + " không đúng định dạng !");
                            return false;
                        }
                    }
                }
            }
            else if (el.fieldTypeCode == FieldTypeCode.MULTIPLE_CHOICE) {

                let arrInputCheck: HTMLInputElement[] = [];
                let selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-multiple-choice#TABLE_' + el.fieldCode + this.queryRegex));
                if (selectorComponent != null) {
                    var multiList: any = selectorComponent.querySelectorAll('nz-form-control label');
                    multiList.forEach(element => {
                        let isChecked = element.getAttribute('data-checked');
                        let dataMultiCode = element.getAttribute('data-nzvalue');
                        if (isChecked == "true" || isChecked == true) {
                            let subInput = <HTMLInputElement>document.getElementById(`${el.fieldCode}-${dataMultiCode}_INPUT`);
                            arrInputCheck.push(subInput);
                            if (!subInput.value) {
                                this.nzModalNotification.error("Error", `Vui lòng nhập ${component_name} !`);
                                flagCheck = false;
                            }                         
                        }
                    });
                }

                if(!flagCheck) return false;

                for(let i = 0; i < el.customfieldOptionList.length; i++){
                    let findCheck = arrInputCheck.find(x => x.name == `${el.customfieldOptionList[i].fieldCode}-${el.customfieldOptionList[i].optionCode}_INPUT`)

                    if(findCheck){
                        let arrPattern = el.customfieldOptionList[i].fieldOptionConfig ? JSON.parse(el.customfieldOptionList[i].fieldOptionConfig) : null;
                        try{
                            for(let key in arrPattern){
                                if(arrPattern[key] == arrPattern.keydownPattern || arrPattern[key] == arrPattern.onchangePattern){
                                    let regexTest = new RegExp(arrPattern[key].toString());
                                    if(!regexTest.test(findCheck.value)){
                                        this.nzModalNotification.error("Error", `${component_name} không đúng định dạng!`);
                                        flagCheck = false;
                                        return;
                                    }
                                }
                            }
                        }
                        catch(e){}
                    }

                    let isChecked = this.formGroup.controls[el.fieldCode + '-' + el.customfieldOptionList[i].optionCode].value;
                    if (isChecked) {
                        this.formGroup.controls[el.fieldCode + '-' + el.customfieldOptionList[i].optionCode].setValue(el.customfieldOptionList[i].selectedInput);
                    }
                }

                if(!flagCheck) return false;
            }
        }

        return true;
    }

    hasValue(controlName: string, nameValue: string) {
        if (nameValue && nameValue.indexOf(FieldTypeCode.MULTIPLE_CHOICE) > -1) {
            let val = this.formGroup.controls[nameValue] ? this.formGroup.controls[nameValue].value : "";
            if (val) {
                return true;
            }

        }
        else if (nameValue && nameValue.indexOf(FieldTypeCode.RADIO_BUTTON) > -1) {
            let el = this.formFieldInfo.find(x => nameValue.indexOf(x.fieldCode) > -1);
            if (el) {
                let radioNameValue = nameValue.substring(el.fieldCode.length + 1);
                let val = this.formGroup.controls[el.fieldCode] ? this.formGroup.controls[el.fieldCode].value : "";
                if (val && val == radioNameValue) {
                    return true;
                }
            }
        }
        else if (controlName) {
            let val = this.formGroup.controls[controlName] ? this.formGroup.controls[controlName].value : "";
            if (val) {
                if (controlName.indexOf(FieldTypeCode.NUMBER) > -1 && (val == "0" || val == 0)) {
                    return false;
                } else {
                    return true;
                }
            }
        }

        return false;
    }

    cancel() {
        this.nzModalRef.destroy();
    }

    selectOutput(item) {
        this.selectChildData = [];
        if (item) {
            if (this.formFieldInfo) {
                var childField = this.formFieldInfo.find(x => {
                    if (x.fieldConfig) {
                        var config = (x.fieldConfig && x.fieldConfig.indexOf('input') > -1) ? JSON.parse(x.fieldConfig) : null;
                        var parentId = config && config.apiConfig && config.apiConfig.request ? config.apiConfig.request.input : '';

                        if (item.fieldInfo.fieldCode == parentId) {
                            return true;
                        }
                    }

                    return false;
                })
            }

            if (childField) {
                this.selectChildData = { fieldCode: childField.fieldCode, data: [] };
                let fieldConfig = childField.fieldConfig ? JSON.parse(childField.fieldConfig) : null;
                if (fieldConfig && fieldConfig.apiConfig.url) {
                    if (item.input && item.input.dataValueField) {
                        this.formsService.callApiUrl(fieldConfig.apiConfig.url, { input: item.input.dataValueField }).subscribe(
                            res => {
                                if (res.result && res.result.length > 0) {
                                    this.selectChildData = { fieldCode: childField.fieldCode, data: res.result };
                                }
                            },
                            error => {
                                console.log(error);
                            }
                        )
                    }
                }
            }
        }
    }

    tableOutput(e) {
        this.formGroup.controls[e.fieldCode].setValue(e.value);
    }

    getSubItemsList(component: FormFieldInfo, value = "") {
        let fieldCode = component.fieldCode;

        if (this.formFieldInfo) {
            var itemList = this.formFieldInfo.filter(x => {
                if (x.formFieldConfig) {
                    let config = JSON.parse(x.formFieldConfig)
                    if (config && config.itemSubSection) {
                        for (const opt of component.customfieldOptionList) {
                            if (config.itemSubSection == opt.fieldCode + '-' + (value ? value : opt.optionCode)) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            });
        } else {
            itemList = [];
        }

        return itemList;
    }

    getMultipleChoiceCustomfieldList(component: FormFieldInfo) {
        var fieldCode = component.fieldCode;
        let formFieldInfo = this.formFieldInfo.filter(x => {
            let fieldConfig = (x.fieldConfig && x.fieldConfig.indexOf('dependentField') > -1) ? JSON.parse(x.fieldConfig) : null;
            if (fieldConfig && fieldConfig.dependentField) {
                return fieldConfig.dependentField.indexOf(component.fieldCode) > -1;
            }
            return false;
        });
        let filteredFormFieldInfo = (formFieldInfo != null) ? formFieldInfo[0] : null;

        if (filteredFormFieldInfo) {
            var filteredCustomfieldOptionList = filteredFormFieldInfo.customfieldOptionList.filter(x => {
                let fieldOptionConfig = x.fieldOptionConfig ? JSON.parse(x.fieldOptionConfig) : null;
                if (fieldOptionConfig) {
                    let filteredOption = fieldOptionConfig.dependentFieldsOption.filter(y => y.fieldCode == fieldCode);
                    let dependentFieldsOption = (filteredOption != null) ? filteredOption[0] : null;
                    return dependentFieldsOption.fieldCode == fieldCode;
                }
                return false;
            });
        }

        return filteredCustomfieldOptionList;
    }

    isShowComponent(component: FormFieldInfo) {
        if (component.formFieldConfig && JSON.parse(component.formFieldConfig)) {
            var itemSubSection = JSON.parse(component.formFieldConfig).itemSubSection ? JSON.parse(component.formFieldConfig).itemSubSection : null;
            if (itemSubSection) {
                return false;
            }
        }

        return true;
    }
}